import type {
	Actions,
	buyerOrdersInput,
	getAllOrdersInput,
	getOneOrderInput,
	getOrderTransferRecordsInput,
	getOrdersFacetsInput,
	orderActionInput,
	sellerOrdersInput,
	sellersForOrderInput,
	updateOrderInput,
} from "@/api/custom_types";
import { createReactQueryKeys } from "@/utils/react-query";

interface Keys {
	useGetOrders: getAllOrdersInput;
	useGetSellerOrders: sellerOrdersInput;
	useGetBuyerOrders: buyerOrdersInput;
	useSellersForOrder: sellersForOrderInput;
	useCreateOrder: undefined;
	useGetOrderById: getOneOrderInput;
	useGetOrderTransferRecord: getOrderTransferRecordsInput;
	useOrderAction: orderActionInput;
	useBatchOrderAction: { action: Actions; orderIds: string[] };
	useUpdateOrder: updateOrderInput;
	useGetOrdersFacet: getOrdersFacetsInput;
}

const ORDER_SERVICE_KEYS = createReactQueryKeys<Keys>("order", [
	"useGetOrders",
	"useGetBuyerOrders",
	"useGetSellerOrders",
	"useSellersForOrder",
	"useCreateOrder",
	"useGetOrderById",
	"useGetOrderTransferRecord",
	"useOrderAction",
	"useBatchOrderAction",
	"useUpdateOrder",
	"useGetOrdersFacet",
]);

export { ORDER_SERVICE_KEYS };
